import { SET_AGGREGATION_CURRENCY, SET_CURRENCY_RATES } from '../constants/actionTypes'
import { storage } from '../storage'

const initialState = {
  aggregationCurrency: storage.getItem('aggregationCurrency') || 'USD',
  currencyRates: {},
  locale: (typeof Intl !== 'undefined') ? Intl.NumberFormat().resolvedOptions().locale : 'en-US'
}

const currencyInfo = (state = initialState, action) => {
  switch (action.type) {
    case SET_AGGREGATION_CURRENCY:
      return Object.assign({}, state, {
        aggregationCurrency: action.aggregationCurrency
      })
    case SET_CURRENCY_RATES:
      return Object.assign({}, state, {
        currencyRates: action.currencyRates
      })
    default:
      return state
  }
}

export default currencyInfo
